import { Store } from '@ngrx/store';
import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate } from '@angular/router';
import * as fromRoot from '../../reducers';
import { selectCurrentUser } from '../../core/selectors/auth';
import { map, take } from 'rxjs/operators';
import { CurrentUserLoaded } from '../../core/actions/auth';
import { Observable } from 'rxjs';
import { UserService } from './userService';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private store: Store<fromRoot.State>,
    private userService: UserService
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.select(selectCurrentUser).pipe(
      map(storedUser => {
        if (storedUser.currentUser) {
          return true;
        } else {
          this.userService
            .getCurrentUser()
            .pipe(take(1))
            .subscribe(user => {
              if (user) {
                this.store.dispatch(
                  new CurrentUserLoaded({ currentUser: user })
                );
                return true;
              } else {
                return false;
              }
            });
        }
      }, take(1))
    );
  }
}
